// ⚠️⚠️⚠️⚠️ AUTO GENERATED FILE ⚠️⚠️⚠️⚠️ DO NOT EDIT ⚠️⚠️⚠️⚠️
/** Internal type. DO NOT USE DIRECTLY. */
type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
/** Internal type. DO NOT USE DIRECTLY. */
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
import type * as Types from '../../schema';

import gql from '@workspace/graphql-codegen-fetch';
export type UserManagementChangeLanguageInput = {
  clientMutationId?: string | null | undefined;
  language: string;
};

export type UpdateUserLanguageMutationVariables = Exact<{
  input: Types.UserManagementChangeLanguageInput;
}>;


export type UpdateUserLanguageMutation = { userManagementChangeLanguage: { success: boolean | undefined } | undefined };


export const UpdateUserLanguageMutationDocument = gql`
    mutation UpdateUserLanguageMutation($input: UserManagementChangeLanguageInput!) {
  userManagementChangeLanguage(input: $input) {
    success
  }
}
    `;